@if (component) {
<div class="flex flex-column-s flex-justify-center wrap"
     [class.flex-middle]="component.columns[0]?.variant === 'quote' || component.columns[1]?.variant === 'quote'">
    @for (column of component?.columns; track column) {
    <div class="c-4 c-5-m c-12-s m-a-0-s m-b-0">
        @switch (column.variant) {
        @default {
        <div [routerLink]="column.url"
             [class.cursor-pointer]="column.url !== ''">
            <div class="overflow-hidden"
                 [ngClass]="column.ratio || 'ratio-1-1'">
                <shell></shell>
                <img [fill]="true"
                     [ratio]="column.ratio || 'ratio-1-1'"
                     [dfImage]="column.image || ''"
                     alt="image">
            </div>
            <p class="c1 p-t-2 col-13"
               [ngClass]="column.caption_align || 'center'"
               *iCms="'caption' of column"></p>
        </div>
        }
        @case ('quote') {
        <div class="center p-l-5-x p-l-5-l p-a-2-m p-t-10-m p-t-10-s">
            <div [ngClass]="column.quote_font_style"
                 *iCms="'quote' of column">
            </div>
            <p class="p1 p-t-2 col-13 m-t-8 m-t-3-m m-t-3-s"
               *iCms="'caption' of column">
            </p>
        </div>
        }
        }
    </div>
    }
</div>
}
